import { axiosClientPortalInstance } from "./";

const getClientPortalCompanies = async (params) =>
  axiosClientPortalInstance.get("/companies", { params });

export { getClientPortalCompanies };
